import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Dropdown from './Dropdown';
var ButtonDropdown = function ButtonDropdown(props) {
  return /*#__PURE__*/React.createElement(Dropdown, _extends({
    group: true
  }, props));
};
export default ButtonDropdown;